module.exports = __webpack_public_path__ + "img/intel.d756075d.svg";